import React from 'react'
import logo from '../assets/logo100.png'

const LoadingComponent: React.FunctionComponent = () => {
    return (
        <div className='flex flex-col items-center justify-center h-full w-full'>
            <img src={logo} alt='logo' className='w-12 h-12 animate-spin' />
            {/* eslint-disable-next-line string-to-lingui/missing-lingui-transformation */}
            <div className='text-lg font-bold mt-2'>Loading...</div>
        </div>
    )
}

export default LoadingComponent
